import { useState } from "react";
import { ExternalLink, FileOutput } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, money } from "@/lib/api";
import { useFetch } from "@/hooks/useFetch";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Spinner } from "@/components/States";

export default function QboPush({ projectId, pushed, dirty, onPushed }) {
  const { data } = useFetch("/qbo/status");
  const [busy, setBusy] = useState(false);
  const push = async (kind) => {
    setBusy(true);
    try {
      const { data: rec } = await api.post(`/projects/${projectId}/estimate/push-qbo`, { kind });
      onPushed(rec); toast.success(`QuickBooks ${kind} #${rec.doc_number || rec.id} created (${money(rec.total || 0)})`);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (!data?.connected) return null;
  return (
    <div className="flex items-center gap-2">
      {pushed && <span className="text-xs text-muted-foreground" data-testid="qbo-pushed-badge"><ExternalLink className="mr-1 inline h-3 w-3" />QuickBooks {pushed.kind} #{pushed.doc_number || pushed.id} · {pushed.pushed_at?.slice(0, 10)}</span>}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="sm" disabled={busy || dirty} title={dirty ? "Save the estimate first" : undefined} data-testid="qbo-push-button">{busy ? <Spinner /> : <FileOutput className="mr-1 h-4 w-4" />}Send to QuickBooks</Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={() => push("estimate")} data-testid="qbo-push-estimate">As an estimate</DropdownMenuItem>
          <DropdownMenuItem onClick={() => push("invoice")} data-testid="qbo-push-invoice">As an invoice</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
